import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useLoading } from "../../../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../../../constants/loadingKeys";
import { toLocalISOWithOffset } from "../../../../../utils";
import { updatePatientRefusalReason } from "../../../../../app/patientSlice";

export const useUnableToAssessWound = () => {
  const dispatch = useDispatch();
  const { patientId } = useParams();
  const isLoading = useLoading(LOADING_KEYS.PATIENT_REFUSAL_REASON);

  const [activeChip, setActiveChip] = useState(null);
  const [notes, setNotes] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSelect = useCallback((key) => {
    setActiveChip((prev) => (prev === key ? null : key));
  }, []);

  const handleConfirm = useCallback(() => {
    if (!activeChip) return;

    const signLockedDate = toLocalISOWithOffset(new Date());
    const payload = {
      ne1Id: patientId,
      refusalReason: activeChip,
      signedDate: signLockedDate,
      lockedDate: signLockedDate,
      notes: notes.trim(),
    };

    dispatch(updatePatientRefusalReason(payload, setIsSuccess));
  }, [dispatch, patientId, activeChip, notes]);

  const handleNoteChange = (e) => {
    setNotes(e.target.value);
  };

  return {
    activeChip,
    notes,
    isSuccess,
    isLoading,
    handleNoteChange,
    handleSelect,
    handleConfirm,
  };
};
